// useMe — query hook for the currently logged-in user. Returns null when
// unauthenticated. Caches across navigation; invalidated on login/logout.

import { useQuery } from '@tanstack/react-query';
import { auth, ApiError } from '@/lib/api';
import type { PublicUser } from '@frt/shared-types';

export function useMe() {
  return useQuery<PublicUser | null>({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        const res = await auth.me();
        return res.user;
      } catch (err) {
        if (err instanceof ApiError && (err.status === 401 || err.status === 403)) {
          return null;
        }
        throw err;
      }
    },
    staleTime: 60_000,
  });
}
